module.exports = " <div class=\"league-admin section\"> <div class=level> <div class=level-left> <h1 class=title>Leagues</h1> </div> <div class=level-right> <league-add></league-add> </div> </div> <div class=leagues> <div class=\"media level\" v-for=\"league in leagues\"> <a v-link=\"{ path: '/leagues/' + league.key }\"> <h2 class=subtitle> {{ league.en.title }} {{league.en.subtitle}} </h2> </a> <a v-link=\"{ path: '/leagues/' + league.key + '/edit' }\" class=button> Edit </a> <button @click=deleteLeague(league) class=\"button is-danger\">Delete</button>  </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeagueAdmin.vue
 ** module id = 49
 ** module chunks = 1
 **/